import { createAction, props } from '@ngrx/store';
import { IProposalData, IProposalModel } from '@partners/api';

export class ProposalActions {
  static reset = createAction('[Proposal] Reset State');
  static load = createAction('[Proposal] Load');
  static loadSuccess = createAction('[Proposal] Load Success', props<{ model: IProposalModel; data: IProposalData }>());
  static loadFailure = createAction('[Proposal] Load Failure', props<{ error: any }>());
  static submit = createAction('[Proposal] Submit');
  static submitSuccess = createAction('[Proposal] Submit Success', props<{ model: IProposalModel; data: IProposalData }>());
  static submitFailure = createAction('[Proposal] Submit Failure', props<{ error: any }>());
}
